import { HttpClient } from "@angular/common/http";
import { Component, Inject, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { AnnouncementResponseModel } from "src/app/model/AnnouncementResponseModel";
// import { ConsoleReporter } from "jasmine";
import { BoardResponseModel } from "src/app/model/BoardResponseModel";
import { LotteryResponseModel } from "src/app/model/LotteryResponseModel";
import { MasterService } from "src/app/services/master.service";



@Component({
  selector: 'app-announcement-au',
  templateUrl: './announcement-au.component.html',
  styleUrls: ['./announcement-au.component.scss'],
})
export class AnnouncementAuComponent implements OnInit {

  announcementKey: number;
  pageMode: string;
  lotteryResponseModel : LotteryResponseModel;
  anouncementResponseModel : AnnouncementResponseModel;
  form: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;
  boardsList: {[key:number]:string};
  stageList: string[];
  announcementType: string[];
  paymentGatewayList: string[];
  isLoading = false;
  selectedFile: File;

  showDraftList: boolean = false;
  showFinalList: boolean = false;
  visible: boolean = false;
  gBase64: string | ArrayBuffer;
  constructor(
    // @Inject(MAT_DIALOG_DATA) public data: any,
    // private boardService: MasterService,
    private masterService: MasterService,
    private _snackBar: MatSnackBar,
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private _formBuilder: FormBuilder
  ) {} 

  ngOnInit() {

    console.log("Announcement AU component on init called");
    this.route.params.subscribe((params: Params) => {
      this.announcementKey = +params["key"];
     
      this.masterService
        .initAnnouncementForm(this.announcementKey)
        .subscribe((data: any) => {
          this.isLoading = true;
          if(data.status === 'SUCCESS') {
            console.log("values from DB *****",data);
            this.boardsList = data.boards;
            this.announcementType = data.announcementType;
            this.stageList = data.stages;
            this.paymentGatewayList = data.paymentGateways;
            console.log(this.paymentGatewayList);
            this.isLoading = false;
            if(this.announcementKey) {
              console.log("Announcement key get for edit " + this.announcementKey);
              this.masterService
              .getAnnouncementBykey(this.announcementKey)
              .subscribe((data: any) => {
                this.anouncementResponseModel = data;
                this.pageMode = "Edit";
                console.log('form mode Edit ******',data);

                this.form.setValue({

                  announcementEn: this.anouncementResponseModel.announcementEn,
	
                  announcementMr: this.anouncementResponseModel.announcementMr,
                 
                  // fileName: this.anouncementResponseModel.file,
                 
                  // announcementType: this.anouncementResponseModel.announcementType,
                  announcementType:{key: this.anouncementResponseModel.announcementType, value: this.anouncementResponseModel.announcementType},
                  boardKey:{key: this.anouncementResponseModel.boardKey, value: this.anouncementResponseModel.boardCode},

                  displaySequence: this.anouncementResponseModel.displaySequence,        
                  // boardId: this.anouncementResponseModel.boardKey
                 
                  // base64: this.gBase64
                });
              });
            }
            else {
              this.pageMode = "Add";
              console.log('form mode add');
            }
          }
          else {
            //toast data.errorMessage
          }
        });
        
     
      this.form = new FormGroup({

        announcementType: new FormControl(null, Validators.required),
        boardKey: new FormControl(null,Validators.required),
        announcementEn: new FormControl(null, Validators.required),
        announcementMr: new FormControl(null, Validators.required),
        displaySequence: new FormControl(null, Validators.required),
      });
    });
  }



  
  onCheckboxChangeDraftPublish(e: any) {
    if(e.target){
      console.log("check box ticked");
    }
  }
  onCheckboxChangeFinalPublish(e: any) {
    if(e.target){
      console.log("check box ticked");
    }
  }
  onCheckboxChangeResult(e: any) {
    if(e.target){
      console.log("check box ticked");
    }
  }


  onFileSelect(event) {
    this.selectedFile = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(this.selectedFile);
    reader.onload = () => {
      this.gBase64 = reader.result
    };

  }

  onDropdownChange(e: any) {

    if(e.value?.value === 'HELP_LINK'){
    this.visible = !this.visible;
   this.form.addControl('file', new FormControl('', Validators.required));
    }else{
      this.visible = false;
      this.form.removeControl('file');
     
    }
  }

  onSubmit() {
    if(this.pageMode === 'Add') {
      console.log("going to save");
      this.saveLottery();
    }
    else {
      console.log("going to update");
      this.updateAnnouncement();
    }
  }



  async saveLottery() {
    console.log("in announcement Lottery");
      console.log("in save Announcement form vaideated");
      console.log(this.form.value.bankVerification);
        this.masterService
        .saveAnnouncement({

          announcementEn: this.form.value.announcementEn,
	
           announcementMr: this.form.value.announcementMr,
          
           fileName: this.form.value.file,
          
           announcementType: this.form.value.announcementType?.key,
          
           displaySequence: this.form.value.displaySequence,        
           boardId: this.form.value.boardKey?.key,
           base64: this.gBase64
         
        }).subscribe((data: any) => {
            if(data.status === 'SUCCESS') {
              this.successToast();
              this.router.navigate(["/secure", "announcement", "list"]);
            }
            else {
              this.isSubmitDisabled = false;
              this.errorToast(data.errorMessage);
            }
          }, error => {
            this.isSubmitDisabled = false;
            console.log(error);
            this.errorToast(error.error.errorMessage, 5*1000);
          });
    } 
    


  async updateAnnouncement() {
    console.log(this.form.value);
    console.log(this.form);
    
    if (this.form.valid) {
      this.masterService
      .updateAnnouncement(this.announcementKey, {



        announcementEn: this.form.value.announcementEn,
	
        announcementMr: this.form.value.announcementMr,
       
        fileName: this.form.value.file,
       
        announcementType: this.form.value.announcementType?.key,
       
        displaySequence: this.form.value.displaySequence,        
        boardId: this.form.value.boardKey?.key,
        base64: this.gBase64





      })
        .subscribe((data: any) => {
          this.isLoading = true;
            if(data.status === 'SUCCESS') {
              this.isLoading = false;
              this.successToast();
              this.router.navigate(["/secure", "announcement","list"]);
            }
            else {
              this.isSubmitDisabled = false;
              this.errorToast(data.errorMessage);
              this.isLoading = false;
            }
          }, error => {
            this.isSubmitDisabled = false;
            console.log(error);
            this.errorToast(error.error.errorMessage, 5*1000);
          });
      
    } else {
      this.isSubmitDisabled = false;
      this.errorToast("Please enter valid data for all fields.");
    }
  }


  async successToast() {
    await this._snackBar.open(
      "Lottery details saved successfully.",
      "Close",
      {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async warningToast() {
    await this._snackBar.open("Please Upload Logo", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "warning-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }

  showBoard(o1: any, o2: any) {
    if(o1 && o2 && o1.key == o2.key) {
      return o1.value;
    }
    else {
      return "";
    }
  }
  showAnnouncement(o1: any, o2: any) {
    if(o1 && o2 && o1 == o2) {
      return o1.value;
    }
    else {
      return "";
    }
  }
  showStage(o1: any, o2: any) {
    if(o1 && o2 && o1 == o2) {
      return o1;
    }
    else {
      return "";
    }
  }

  showPaymentGateway(o1: any, o2: any) {
    if(o1 && o2 && o1 == o2) {
      return o1;
    }
    else {
      return "";
    }
  }

  showRoleType(o1: any, o2: any) {
    console.log(o1, o2, o1 == o2);
    if(o1 && o2 && o1 == o2) {
      return o1;
    }
    else {
      return "";
    }
  }
  
  englishToMarathi() {
    window.open("https://translate.google.com/",
     "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=250,left=200,width=800,height=400");
  }
  marathiToUniCode() {
    window.open("https://www.pramukhfontconverter.com/marathi/aps-c-dv-prakash-to-unicode",
     "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=250,left=200,width=800,height=400");
  }



}
